import MoreFeatures from './MoreFeatures'

export default class ProPlan extends React.PureComponent

  formattedPrice: ->
    new Intl.NumberFormat(@props.currentLocale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(@props.price)

  render: ->
    <div className="card plan-card pro-plan rainbow-outline rainbow-animated rainbow-hover-grow">
      <div className="card-body gradient-background">
        { @renderMostPopular() }
        { @renderTitle()       }
        { @renderPrice()       }
        { @renderCtaButton()   }

        <hr/>

        <h4>
          {@props.i18n.dataPrivacy}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.fullPrivacy }} />
          </li>
        </ul>

        <hr/>

        <h4>
          {@props.i18n.models}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-check" />
            <strong>{@props.i18n.premiumModels}</strong>
          </li>
          <li>
            <i className="far fa-circle-check" />
            {@props.i18n.basicModels}
          </li>
        </ul>

        <hr/>

        <h4>
          {@props.i18n.translationLimits}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.unlimitedUsage }} />
          </li>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.interfaceChars }} />
          </li>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.noClipboardWatermark }} />
          </li>
        </ul>

        <div className="flex-grow-1" />

        <MoreFeatures visible={@props.moreFeaturesVisible}
                      toggle={@props.toggleMoreFeatures}
                      i18n={@props.i18n.moreFeatures} />
      </div>
    </div>

  renderMostPopular: ->
    <span className="most-popular left">
      {@props.i18n.mostPopular}
    </span>

  renderTitle: ->
    <h3>
      {@props.i18n.title}
    </h3>

  renderPrice: ->
    classes = "price big"
    classes += " flashed" if @props.priceIsFlashed

    <div className={classes}>
      <span className="amount">
        {@formattedPrice()}
      </span>
      <span className="currency">
        &euro;
      </span>
      <span className="period">
        {@props.i18n.price.period}
      </span>
    </div>

  renderCtaButton: ->
    <button className="btn btn-primary"
            onClick={@props.onClickProButton}>
      {@props.i18n.ctaButton.upgrade}
    </button>
